import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './modules/auth/services/auth.guard';

export const AppRouting: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth-routing').then((m) => m.AuthRouting),
  },
  {
    path: 'error',
    loadChildren: () =>
      import('./modules/errors/errors-routing').then((m) => m.ErrorsRouting),
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/routing').then((m) => m.Routing),
  },
  { path: '**', redirectTo: 'error/404' },
];

@NgModule({
  imports: [RouterModule.forRoot(AppRouting, {
    initialNavigation: 'enabledBlocking'
})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
